/**
 * Ersatz für node_modules/expo-router/_ctx.web.js im Webpack-Web-Build.
 * require.context() wird relativ zu dieser Datei (Projektroot) aufgelöst,
 * daher ist "./app" hier korrekt.
 */
export const ctx = require.context(
  "./app",
  true,
  /^(?:\.\/)(?!(?:(?:(?:.*\+api)|(?:\+middleware)|(?:\+(html|native-intent))))\.[tj]sx?$).*(?:\.android|\.ios|\.native)?\.[tj]sx?$/,
  "sync"
);
